import React from 'react'

import PropTypes from 'prop-types'
import {Grid, Typography, withStyles, Card, CardContent} from '@material-ui/core'
import styles from './styles'

/**
 * These are the payment means and information on how to pay with the them for the PagoMisCuentas payment method
 *
 * @param classes: {Object} containing the JSS classes for the current component to use.
 * @param pmcLogoUrl: {String} containing PagoMisCuentas icon path.
 * @param homebankingLogoUrl: {String} containing homebanking icon path.
 */
const PmcPaymentMeans = ({classes, pmcLogo, homebankingLogo}) => (
  <Grid container justify={"center"} spacing={Number(16)}>
      <Grid item xs={12} sm={6}>
        <Card className={classes.feedbackCard}>
          <CardContent>
            <Grid item xs={"auto"} className={classes.paymentMeanLogoContainer}>
              <img alt="" src={pmcLogo} className={classes.paymentMeanLogo}/>
            </Grid>
            <Typography className={classes.cardTitle}>
              Ingresando a<br/>
            </Typography>
            <Typography className={classes.cardTitleBold}>
              PagoMisCuentas
            </Typography>
            <div className={classes.cardInstructions}>
              <Typography className={classes.cardInstruction}>
                1 - Ingresar a pagomiscuentas.com<br/>
              </Typography>
              <Typography className={classes.cardInstruction}>
                2 - Seleccionar el banco <br/>
              </Typography>
              <Typography className={classes.cardInstruction}>
                3 - Completar datos de acceso para ejecutar el pago
              </Typography>
            </div>
          </CardContent>
        </Card>
      </Grid>
      <Grid item xs={12} sm={6}>
        <Card className={classes.feedbackCard}>
          <CardContent>
            <Grid item xs={"auto"} className={classes.paymentMeanLogoContainer}>
              <img alt="" src={homebankingLogo} className={classes.paymentMeanLogo}/>
            </Grid>
            <Typography className={classes.cardTitle}>
              Ingresando a su<br/>
            </Typography>
             <Typography className={classes.cardTitleBold}>
               Homebanking
             </Typography>
             <div className={classes.cardInstructions}>
               <Typography className={classes.cardInstruction}>
                 1 - Ingresar al homebanking del Banco anteriormente seleccionado.<br/>
               </Typography>
               <Typography className={classes.cardInstruction}>
                 2 - Ir a pagos y transferencias <br/>
               </Typography>
               <Typography className={classes.cardInstruction}>
                 3 - Seleccionar la opción Pago Mis Cuentas en el apartado de Pagos
               </Typography>
             </div>
             <Typography className={classes.cardInstructions}>
             </Typography>
          </CardContent>
        </Card>
      </Grid>
  </Grid>
)

PmcPaymentMeans.propTypes = {
    pmcLogo: PropTypes.func.isRequired,
    homebankingLogo: PropTypes.func.isRequired
}

const Styled = withStyles(styles)(PmcPaymentMeans)

export default Styled
